import { getFailedCartIndices } from './cartStaffCheckout';

/**
 * Build rows for CheckoutLeftoversDialog after a partial or split cart checkout.
 * @param {object} params
 * @param {Array<{ item: object, index: number }>} params.selectedCartEntries
 * @param {Array<{ index: number, error?: string }>} [params.itemErrors]
 * @param {Array<object>} params.cartItems Before retainItemsByIndices
 * @param {Set<number>} params.selectedIndices
 * @param {(item: object) => string} params.getItemLabel
 * @param {(item: object) => string} params.getItemDetails
 * @param {(key: string) => string} params.t
 */
export function buildCheckoutLeftoverRows({
  selectedCartEntries,
  itemErrors,
  cartItems,
  selectedIndices,
  getItemLabel,
  getItemDetails,
  t,
}) {
  const rows = [];
  const failedCheckoutIndices = new Set(getFailedCartIndices(itemErrors));

  failedCheckoutIndices.forEach((checkoutIdx) => {
    const entry = selectedCartEntries[checkoutIdx];
    const item = entry?.item;
    if (!item) return;
    const errEntry = (itemErrors || []).find((e) => e.index === checkoutIdx);
    rows.push({
      label: getItemLabel(item),
      details: getItemDetails(item),
      error: errEntry?.error || t('common.error'),
    });
  });

  cartItems.forEach((item, cartIndex) => {
    if (selectedIndices.has(cartIndex)) return;
    rows.push({
      label: getItemLabel(item),
      details: getItemDetails(item),
      error: t('cart.checkoutLeftoverStillInCart'),
    });
  });

  return rows;
}
